import { CONTENT_METRIC_VERSION, CONTENT_EVENTS, classifyContentSource } from '@mts/shared/contentMetrics';
import { getApiBaseUrl } from './api.js';
import { COOKIE_CATEGORIES, isConsentGiven } from './cookieConsentState.js';
import { getOrCreateVisitorId } from './visitorTracking.js';

export function canMeasureArticle(post, location = window.location) {
  if (!post?.id || post.isPreview || post.status !== 'PUBLISHED' || !post.publishedAt || new Date(post.publishedAt) > new Date()) return false;
  if (!isConsentGiven(COOKIE_CATEGORIES.ANALYTICS) || navigator.doNotTrack === '1' || navigator.globalPrivacyControl || navigator.webdriver) return false;
  const url = new URL(location.href);
  return url.pathname === `/blog/${encodeURIComponent(post.slug)}` && ![...url.searchParams.keys()].some(key => /preview|embed|test|token|authorization/i.test(key));
}
export async function measureArticle({ post, pageId, eventType = CONTENT_EVENTS.VIEW, targetId, action, targetKey }) {
  try {
  if (!pageId || !canMeasureArticle(post)) return false;
  const url = new URL(window.location.href);
  let referrerOrigin = '';
  try { if (document.referrer) referrerOrigin = new URL(document.referrer).origin; } catch { referrerOrigin = undefined; }
  const referrerClass = classifyContentSource({ referrerOrigin, pageOrigin: url.origin });
  referrerOrigin = { DIRECT: '', ORGANIC_SEARCH: 'https://www.google.com', SOCIAL: 'https://www.facebook.com', REFERRAL: 'https://referral.invalid' }[referrerClass];
  const safeMedium = (url.searchParams.get('utm_medium') || '').toLowerCase();
  const medium = ['cpc','ppc','paid','paid_social','display','affiliate','email','newsletter','social','social-network','social_media','organic'].includes(safeMedium) ? safeMedium : safeMedium ? 'other' : '';
  const source = url.searchParams.has('utm_source') ? 'tagged' : '';
  const distributionId = url.searchParams.get('mts_distribution');
  const payload = {
    version: CONTENT_METRIC_VERSION, eventType, eventKey: eventType === CONTENT_EVENTS.VIEW ? pageId : crypto.randomUUID(), pageId, publicationId: post.id,
    visitorId: getOrCreateVisitorId(), consent: true, pageUrl: `${url.origin}${url.pathname}`,
    referrerOrigin, medium, source,
    ...(targetId ? { targetId } : {}), ...(action ? { action } : {}), ...(targetKey ? { targetKey } : {}),
    ...(/^[a-f0-9-]{36}$/i.test(distributionId || '') ? { distributionId } : {}),
  };
  try { const response = await fetch(`${getApiBaseUrl()}/api/content/measurement`, { method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify(payload), credentials: 'omit', keepalive: true }); return response.ok && (await response.json()).accepted === true; } catch { return false; }
  } catch { return false; }
}
export async function trackArticleAction(event, post, pageId) {
  try {
  if (!pageId || !canMeasureArticle(post)) return;
  const target = event.target.closest?.('a'); if (!target || !event.currentTarget.contains(target)) return;
  const card = target.closest('[data-content-listing-card]'), offer = target.closest('[data-content-offer-card]');
  if (card?.dataset.listingId && ['view','phone','website','directions'].includes(target.dataset.listingAction)) {
    void measureArticle({ post, pageId, eventType: CONTENT_EVENTS.BUSINESS, targetId: card.dataset.listingId, action: target.dataset.listingAction });
  } else if (offer?.dataset.offerId) {
    void measureArticle({ post, pageId, eventType: CONTENT_EVENTS.OFFER, targetId: offer.dataset.offerId, action: 'offer' });
  } else if (target.hasAttribute('data-content-button')) {
    const href = target.getAttribute('href'); if (!href) return;
    const bytes = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(href));
    const targetKey = [...new Uint8Array(bytes)].map(value => value.toString(16).padStart(2,'0')).join('');
    void measureArticle({ post, pageId, eventType: CONTENT_EVENTS.CTA, action: 'button', targetKey });
  }
  } catch { /* Measurement must never interrupt navigation. */ }
}
